import { useState } from "react";
import Error from "../Layouts/Error";
import InnerHeader from "../Layouts/InnerHeader";
import Loading from "../Layouts/Loading";
import { useCheckDomainQuery } from "../Redux/Apis/panelApi";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function Domain() {    
    const [check,checkMe] = useState(0)
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useCheckDomainQuery({check})
    
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess){
        return(
        <div className="container-lg">
            <InnerHeader name="مدیریت دامنه"/>
            <div className="d-flex justify-content-center align-items-center">
                <div className="col-md-6 mt-4">
                    {data.status === true ? 
                        <div className="border border-3 border-success rounded-top"></div>
                        :
                        <div className="border border-3 border-warning rounded-top"></div>
                    }
                    <div className="bg-white shadow p-5 rounded-bottom">
                        <div className="mb-4 text-center">
                            {data.status === true ? 
                                <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75"
                                    fill="currentColor" className="bi bi-check-circle text-success" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path
                                        d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" fill="currentColor" className="bi bi-x-circle text-danger" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            }
                        </div>
                        {data.status === true ? 
                            <div className="text-center">
                                <h1 className="text-success">تبریک!</h1>
                                <p>دامنه شما به پنل لینکت متصل می باشد.</p>
                                <Link to="/" className="btn btn-outline-success">بازگشت به داشبورد</Link>
                            </div>
                            :
                            <div className="text-center">
                                <h1 className="text-danger">عدم اتصال!</h1>
                                <p>دامنه شما هنوز به درستی به پنل لینکت متصل نشده است.</p>
                                <div className="p-2 mb-2 bg-info bg-opacity-10 border border-info rounded">
                                    <p>بررسی نمایید که دامنه شما روی ns های زیر تنظیم شده باشد.</p>
                                    <button className="d-inline btn btn-outline-secondary me-2" onClick={() => {navigator.clipboard.writeText("ns1.linket.me"); toast.info('به کلیپبورد اضافه شد.');}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                        </svg>
                                    </button>
                                    <p className="d-inline font-monospace fs-5">ns1.linket.me</p> 
                                    <br /> <br />
                                    <button className="d-inline btn btn-outline-secondary me-2" onClick={() => {navigator.clipboard.writeText("ns2.linket.me"); toast.info('به کلیپبورد اضافه شد.');}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                        </svg>
                                    </button>
                                    <p className="d-inline font-monospace fs-5">ns2.linket.me</p>
                                </div>
                                <button disabled={isLoading} className="btn btn-outline-primary" onClick={() => checkMe(prev => prev + 1)}>بررسی مجدد</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )}

    else return <></>
}